import React, { useState, useEffect, useCallback, useRef } from 'react';
import Tutorial from '../../../components/Tutorial/Tutorial';
import { TUTORIALES } from '../../../constants/tutorialesConfig';
import { SELECCIONES, CLUBS, ShirtSVG } from '../../CardJugador/CardJugador';
import {
  obtenerFormacionActiva,
  obtenerJugadoresFormacion,
  guardarResultadoFormacion,
  checkCooldownFormaciones,
  normalizar,
} from './formacionesMiticasLogic';
import './formacionesMiticasStyles.css';

const POSICIONES_CANCHA = {
  '4-3-1-2': [
    { x: 50, y: 88 },
    { x: 82, y: 70 }, { x: 62, y: 70 }, { x: 38, y: 70 }, { x: 18, y: 70 },
    { x: 25, y: 52 }, { x: 50, y: 52 }, { x: 75, y: 52 },
    { x: 50, y: 36 },
    { x: 33, y: 20 }, { x: 67, y: 20 },
  ],
  '4-1-2-3': [
    { x: 50, y: 88 },
    { x: 82, y: 70 }, { x: 62, y: 70 }, { x: 38, y: 70 }, { x: 18, y: 70 },
    { x: 50, y: 54 },
    { x: 28, y: 38 }, { x: 72, y: 38 },
    { x: 15, y: 20 }, { x: 50, y: 18 }, { x: 85, y: 20 },
  ],
  '4-4-2': [
    { x: 50, y: 88 },
    { x: 82, y: 70 }, { x: 60, y: 70 }, { x: 40, y: 70 }, { x: 18, y: 70 },
    { x: 82, y: 48 }, { x: 58, y: 48 }, { x: 42, y: 48 }, { x: 18, y: 48 },
    { x: 33, y: 22 }, { x: 67, y: 22 },
  ],
  '4-3-3': [
    { x: 50, y: 88 },
    { x: 82, y: 70 }, { x: 60, y: 70 }, { x: 40, y: 70 }, { x: 18, y: 70 },
    { x: 25, y: 48 }, { x: 50, y: 48 }, { x: 75, y: 48 },
    { x: 15, y: 22 }, { x: 50, y: 18 }, { x: 85, y: 22 },
  ],
  '3-5-2': [
    { x: 50, y: 88 },
    { x: 25, y: 70 }, { x: 50, y: 70 }, { x: 75, y: 70 },
    { x: 88, y: 48 }, { x: 65, y: 48 }, { x: 50, y: 48 }, { x: 35, y: 48 }, { x: 12, y: 48 },
    { x: 33, y: 22 }, { x: 67, y: 22 },
  ],
  '5-3-2': [
    { x: 50, y: 88 },
    { x: 90, y: 70 }, { x: 70, y: 70 }, { x: 50, y: 70 }, { x: 30, y: 70 }, { x: 10, y: 70 },
    { x: 25, y: 48 }, { x: 50, y: 48 }, { x: 75, y: 48 },
    { x: 33, y: 22 }, { x: 67, y: 22 },
  ],
  '4-2-3-1': [
    { x: 50, y: 88 },
    { x: 82, y: 70 }, { x: 60, y: 70 }, { x: 40, y: 70 }, { x: 18, y: 70 },
    { x: 65, y: 54 }, { x: 35, y: 54 },
    { x: 82, y: 36 }, { x: 50, y: 34 }, { x: 18, y: 36 },
    { x: 50, y: 18 },
  ],
};

const generarPosicionesFallback = (formacion) => {
  const partes = formacion.split('-').map(Number);
  const filas = [1, ...partes];
  const pos = [];
  filas.forEach((count, fila) => {
    const y = 88 - fila * (70 / (filas.length - 1));
    for (let i = 0; i < count; i++) {
      const x = count === 1 ? 50 : 10 + (i / (count - 1)) * 80;
      pos.push({ x, y });
    }
  });
  return pos;
};

const obtenerPosiciones = (formacion) =>
  POSICIONES_CANCHA[formacion] || generarPosicionesFallback(formacion);

const getCamisetaColors = (jugador, contextoClub) => {
  if (contextoClub && SELECCIONES[contextoClub]) return SELECCIONES[contextoClub];
  if (contextoClub && CLUBS[contextoClub]) return CLUBS[contextoClub];
  const clubSigla = jugador?.club?.sigla;
  if (clubSigla && CLUBS[clubSigla]) return CLUBS[clubSigla];
  return { p: '#1a3a5c', s: '#ffffff', shirt: 'solida' };
};

const Guiones = ({ apellido }) => {
  const palabras = apellido.split(' ');
  return (
    <div className="fm-guiones">
      {palabras.map((pal, wi) => (
        <React.Fragment key={wi}>
          {wi > 0 && <div style={{ width: '4px' }} />}
          {Array.from({ length: pal.length }).map((_, li) => (
            <div key={li} className="fm-guion" />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

const LineasCancha = () => (
  <svg viewBox="0 0 100 133" xmlns="http://www.w3.org/2000/svg"
    className="fm-cancha-lineas" preserveAspectRatio="none"
    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
    <rect x="2" y="2" width="96" height="129" fill="none" stroke="white" strokeWidth="0.8" opacity="0.6" />
    <line x1="2" y1="66.5" x2="98" y2="66.5" stroke="white" strokeWidth="0.6" opacity="0.5" />
    <circle cx="50" cy="66.5" r="12" fill="none" stroke="white" strokeWidth="0.6" opacity="0.5" />
    <circle cx="50" cy="66.5" r="0.8" fill="white" opacity="0.5" />
    <rect x="18" y="100" width="64" height="29" fill="none" stroke="white" strokeWidth="0.6" opacity="0.5" />
    <rect x="32" y="114" width="36" height="17" fill="none" stroke="white" strokeWidth="0.5" opacity="0.4" />
    <rect x="18" y="4" width="64" height="29" fill="none" stroke="white" strokeWidth="0.6" opacity="0.5" />
    <rect x="32" y="4" width="36" height="17" fill="none" stroke="white" strokeWidth="0.5" opacity="0.4" />
    <circle cx="50" cy="107" r="0.8" fill="white" opacity="0.5" />
    <circle cx="50" cy="26" r="0.8" fill="white" opacity="0.5" />
  </svg>
);

// ── Cancha de solo lectura (para yaJugo y gameover) ──────────────────────────
const CanchaDisplay = ({ jugadores, formacion, resueltos, contextoClub }) => {
  const posiciones = formacion ? obtenerPosiciones(formacion) : [];
  return (
    <div className="fm-cancha-wrap" style={{ pointerEvents: 'none' }}>
      <LineasCancha />
      {jugadores.map((j, idx) => {
        const pos = posiciones[j.slot] || posiciones[idx] || { x: 50, y: 50 };
        const esResuelto = resueltos ? resueltos.has(j.id) : true;
        const colors = getCamisetaColors(j, contextoClub);
        return (
          <div key={j.id} className="fm-slot" style={{ left: `${pos.x}%`, top: `${pos.y}%` }}>
            <div className="fm-camiseta-wrap" style={{
              opacity: 1,
              filter: esResuelto ? 'drop-shadow(0 0 10px #22c55e) drop-shadow(0 0 20px #22c55eaa)' : 'none',
            }}>
              <ShirtSVG p={colors.p} s={colors.s} shirt={colors.shirt}
                dorsal={j.numero_camiseta ? String(j.numero_camiseta) : undefined} />
            </div>
            <div className="fm-nombre-resuelto">{j.apellido}</div>
          </div>
        );
      })}
    </div>
  );
};

const TIEMPO_INICIAL = 150;
const STORAGE_KEY = 'fm_gameover_v2';

const FormacionesMiticas = ({ session }) => {
  const [estado, setEstado]           = useState('cargando');
  const [formacion, setFormacion]     = useState(null);
  const [jugadores, setJugadores]     = useState([]);
  const [resueltos, setResueltos]     = useState(new Set());
  const [input, setInput]             = useState('');
  const [inputEstado, setInputEstado] = useState('');
  const [feedback, setFeedback]       = useState('');
  const [tiempo, setTiempo]           = useState(TIEMPO_INICIAL);
  const [gano, setGano]               = useState(false);
  const [guardando, setGuardando]     = useState(false);
  const [tutorialListo, setTutorialListo] = useState(false);

  const timerRef     = useRef(null);
  const inputRef     = useRef(null);
  const guardadoRef  = useRef(false);
  const jugadoresRef = useRef([]);
  const resueltosRef = useRef(new Set());
  const tiempoRef    = useRef(TIEMPO_INICIAL);
  const sessionRef   = useRef(session);
  const formacionRef = useRef(null);

  // ── 1. Al montar: primero revisar si hay gameover guardado en sessionStorage ──
  useEffect(() => {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const d = JSON.parse(saved);
        setGano(d.gano);
        setResueltos(new Set(d.resueltos || []));
        setTiempo(d.tiempo ?? 0);
        setFormacion(d.formacion);
        setJugadores(d.jugadores || []);
        jugadoresRef.current = d.jugadores || [];
        resueltosRef.current = new Set(d.resueltos || []);
        setEstado('gameover');
        return; // no cargar desde DB
      } catch(e) {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    }
    // Si no hay gameover guardado, cargar normalmente
    const cargar = async () => {
      const f = await obtenerFormacionActiva();
      if (!f) { setEstado('error'); return; }
      if (session?.user?.id) {
        const yaJugo = await checkCooldownFormaciones(session.user.id, f.id);
        if (yaJugo) {
          // Cargar jugadores igual para mostrar la cancha
          const jug = await obtenerJugadoresFormacion(f.id);
          setFormacion(f);
          setJugadores(jug);
          setEstado('yaJugo');
          return;
        }
      }
      const jug = await obtenerJugadoresFormacion(f.id);
      setFormacion(f);
      setJugadores(jug);
      setEstado('jugando');
    };
    cargar();
  }, []); // eslint-disable-line

  // Sincronizar refs
  useEffect(() => { jugadoresRef.current = jugadores; }, [jugadores]);
  useEffect(() => { sessionRef.current = session; }, [session]);
  useEffect(() => { if (formacion) formacionRef.current = formacion; }, [formacion]);

  // ── 2. Guardar gameover en sessionStorage cuando cambia estado ──
  useEffect(() => {
    if (estado === 'gameover') {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        gano,
        resueltos: [...resueltosRef.current],
        tiempo: tiempoRef.current,
        formacion: formacionRef.current,
        jugadores: jugadoresRef.current,
      }));
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    if (estado === 'jugando') {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    return () => { document.body.style.overflow = ''; };
  }, [estado]); // eslint-disable-line

  // ── 3. Timer — solo arranca cuando estado=jugando Y tutorialListo=true ──
  useEffect(() => {
    if (estado !== 'jugando' || !tutorialListo) return;
    timerRef.current = setInterval(() => {
      setTiempo(t => {
        const nuevo = t - 1;
        tiempoRef.current = nuevo;
        if (nuevo <= 0) {
          clearInterval(timerRef.current);
          terminarJuego(false);
          return 0;
        }
        return nuevo;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [estado, tutorialListo]); // eslint-disable-line

  // ── Terminar juego ──
  const terminarJuego = useCallback((victoriaForzada = false) => {
    if (guardadoRef.current) return;
    guardadoRef.current = true;
    clearInterval(timerRef.current);
    const totalResueltos = resueltosRef.current.size;
    const totalJugadores = jugadoresRef.current.length;
    const gano_ = victoriaForzada || totalResueltos === totalJugadores;
    setGano(gano_);
    setEstado('gameover');
    const sess = sessionRef.current;
    const form = formacionRef.current;
    if (sess?.user?.id && form) {
      setGuardando(true);
      guardarResultadoFormacion(
        sess.user.id, form.id, totalResueltos, totalJugadores, tiempoRef.current ?? 0
      ).finally(() => setGuardando(false));
    }
  }, []); // eslint-disable-line

  // ── Verificar input ──
  const verificar = useCallback(() => {
    const val = normalizar(input);
    if (!val) return;
    const match = jugadores.find(j => !resueltos.has(j.id) && normalizar(j.apellido) === val);
    if (match) {
      setResueltos(prev => {
        const nuevo = new Set(prev);
        nuevo.add(match.id);
        resueltosRef.current = nuevo;
        if (nuevo.size === jugadoresRef.current.length) {
          clearInterval(timerRef.current);
          setTimeout(() => terminarJuego(true), 600);
        }
        return nuevo;
      });
      setInput('');
      setInputEstado('correcto');
      setFeedback(`✓ ${match.apellido}${match.nombre ? ', ' + match.nombre.split(' ')[0] : ''}`);
      setTimeout(() => { setInputEstado(''); setFeedback(''); }, 1200);
    } else {
      setInputEstado('error');
      setFeedback('No encontrado — probá otro');
      setTimeout(() => { setInputEstado(''); setFeedback(''); }, 1000);
    }
    inputRef.current?.focus();
  }, [input, jugadores, resueltos, terminarJuego]);

  const handleKeyDown = (e) => { if (e.key === 'Enter') verificar(); };

  const formatTiempo = (s) => {
    const m = Math.floor(s / 60);
    const ss = s % 60;
    return `${m}:${ss.toString().padStart(2, '0')}`;
  };

  const handleVolver = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    window.history.back();
  };

  // ── Renders de estados especiales ──
  if (estado === 'cargando') return (
    <div className="fm-wrapper">
      <div className="fm-loading">
        <div style={{ width: '36px', height: '36px', border: '3px solid #1e293b', borderTop: '3px solid #f59e0b', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        Cargando formación...
      </div>
    </div>
  );

  if (estado === 'error') return (
    <div className="fm-wrapper">
      <div className="fm-loading" style={{ color: '#ef4444' }}>
        No hay formación activa. Volvé más tarde.
      </div>
    </div>
  );

  if (estado === 'yaJugo') return (
    <div className="fm-wrapper">
      {/* Mensaje */}
      <div style={{ textAlign: 'center', padding: '24px 16px 12px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '2.5rem' }}></span>
        <p style={{ color: '#f59e0b', fontWeight: 'bold', margin: 0, fontSize: '1.1rem' }}>Ya jugaste hoy</p>
        <p style={{ color: '#64748b', fontSize: '0.85rem', margin: 0 }}>
          La formación se renueva periódicamente. Volvé pronto.
        </p>
        {formacion && (
          <p style={{ color: '#94a3b8', fontSize: '0.85rem', margin: 0, fontWeight: 'bold' }}>
            {formacion.equipo} — {formacion.competencia}
          </p>
        )}
      </div>
      {/* Cancha con todos los jugadores revelados */}
      {jugadores.length > 0 && (
        <CanchaDisplay
          jugadores={jugadores}
          formacion={formacion?.formacion}
          resueltos={null} // null = todos visibles
          contextoClub={formacion?.contexto_club}
        />
      )}
      {session?.user?.id && (
        <Tutorial
          tutorialId="formaciones_miticas"
          userId={session.user.id}
          pasos={TUTORIALES.formaciones_miticas || []}
          botonVerDeNuevo={true}
          onFin={() => setTutorialListo(true)}
        />
      )}
    </div>
  );

  const posiciones = formacion ? obtenerPosiciones(formacion.formacion) : [];

  return (
    <div className="fm-wrapper">

      {/* Header */}
      <div className="fm-header">
        <div className="fm-header-info">
          <p className="fm-titulo">Formaciones Míticas</p>
          <p className="fm-subtitulo">{formacion?.equipo} — {formacion?.competencia}</p>
        </div>
        {estado === 'jugando' && (
          <div className="fm-progreso">
            <span className="fm-progreso-texto">
              <span className="fm-progreso-valor">{resueltos.size}</span>/{jugadores.length} jugadores
            </span>
          </div>
        )}
        {estado === 'jugando' && (
          <div className="fm-timer">
            <span className={`fm-timer-value${tiempo <= 30 ? ' urgente' : ''}`}>
              {tutorialListo ? formatTiempo(tiempo) : '—'}
            </span>
            <span className="fm-timer-label">tiempo</span>
          </div>
        )}
      </div>

      {/* Cancha */}
      <div className="fm-cancha-wrap">
        <LineasCancha />
        {jugadores.map((j, idx) => {
          const pos = posiciones[j.slot] || posiciones[idx] || { x: 50, y: 50 };
          const esResuelto = resueltos.has(j.id);
          const colors = getCamisetaColors(j, formacion?.contexto_club);
          return (
            <div key={j.id} className="fm-slot" style={{ left: `${pos.x}%`, top: `${pos.y}%` }}>
              <div className="fm-camiseta-wrap" style={{
                opacity: esResuelto ? 1 : 0.45,
                filter: esResuelto ? 'drop-shadow(0 0 10px #22c55e) drop-shadow(0 0 20px #22c55eaa)' : 'none',
                transition: 'opacity 0.3s ease, filter 0.3s ease',
              }}>
                <ShirtSVG p={colors.p} s={colors.s} shirt={colors.shirt}
                  dorsal={j.numero_camiseta ? String(j.numero_camiseta) : undefined} />
              </div>
              {esResuelto
                ? <div className="fm-nombre-resuelto">{j.apellido}</div>
                : <Guiones apellido={j.apellido} />
              }
            </div>
          );
        })}
      </div>

      {/* Input */}
      {estado === 'jugando' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <div className="fm-input-zona">
            <input
              ref={inputRef}
              className={`fm-input${inputEstado ? ' ' + inputEstado : ''}`}
              placeholder={tutorialListo ? 'ESCRIBÍ UN APELLIDO...' : 'Cerrá el tutorial para empezar...'}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              autoComplete="off" autoCorrect="off" spellCheck={false}
              disabled={!tutorialListo}
            />
            <button className="fm-btn-enviar" onClick={verificar} disabled={!input.trim() || !tutorialListo}>
              Enviar
            </button>
          </div>
          <div className={`fm-feedback${inputEstado ? ' ' + inputEstado : ''}`}>
            {feedback || '\u00A0'}
          </div>
        </div>
      )}

      {/* Game Over */}
      {estado === 'gameover' && (
        <div className="fm-gameover">
          <div className="fm-gameover-card">
            <h2 className={`fm-gameover-titulo ${gano ? 'gano' : 'perdio'}`}>
              {gano ? ' ¡COMPLETADO!' : ' TIEMPO'}
            </h2>
            <div className="fm-gameover-stats">
              <div className="fm-stat-card">
                <p className="fm-stat-label">Encontrados</p>
                <p className="fm-stat-valor">{resueltos.size}/{jugadores.length}</p>
              </div>
              <div className="fm-stat-card">
                <p className="fm-stat-label">Tiempo restante</p>
                <p className="fm-stat-valor">{formatTiempo(tiempo)}</p>
              </div>
            </div>
            <div className="fm-go-lista">
              {jugadores.slice().sort((a, b) => a.slot - b.slot).map(j => (
                <div key={j.id} className={`fm-go-jugador ${resueltos.has(j.id) ? 'ok' : 'miss'}`}>
                  <span style={{ fontSize: '0.75rem', opacity: 0.6, minWidth: '16px' }}>{j.numero_camiseta || '?'}</span>
                  <span style={{ fontSize: '0.7rem', opacity: 0.5, minWidth: '32px' }}>{j.posicion?.sigla || ''}</span>
                  <span style={{ flex: 1, fontWeight: 'bold' }}>{j.apellido}{j.nombre ? `, ${j.nombre.split(' ')[0]}` : ''}</span>
                  <span style={{ fontSize: '0.9rem' }}>{resueltos.has(j.id) ? '✓' : '✗'}</span>
                </div>
              ))}
            </div>
            <p style={{ color: '#64748b', fontSize: '0.78rem', textAlign: 'center', margin: 0 }}>
              {formacion?.equipo} — {formacion?.competencia}
            </p>
            {guardando && <p style={{ color: '#64748b', fontSize: '0.75rem', textAlign: 'center', margin: 0 }}>Guardando resultado...</p>}
            <button className="fm-btn-jugar-de-nuevo" disabled style={{ opacity: 0.4 }}>
              Volvé mañana para la próxima formación
            </button>
            <button onClick={handleVolver}
              style={{ width: '100%', padding: '10px', background: 'transparent', border: '1px solid #1e293b', borderRadius: '10px', color: '#64748b', fontWeight: 'bold', fontSize: '0.9rem', cursor: 'pointer', transition: '0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#475569'; e.currentTarget.style.color = '#94a3b8'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#1e293b'; e.currentTarget.style.color = '#64748b'; }}>
              ← Volver a Minijuegos
            </button>
          </div>
        </div>
      )}

      {/* Tutorial — solo mientras jugando */}
      {estado === 'jugando' && session?.user?.id && (
        <Tutorial
          tutorialId="formaciones_miticas"
          userId={session.user.id}
          pasos={TUTORIALES.formaciones_miticas || []}
          botonVerDeNuevo={true}
          onFin={() => setTutorialListo(true)}
        />
      )}
    </div>
  );
};

export default FormacionesMiticas;